/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type BillingChangePreviewRequestPlanSlug = typeof BillingChangePreviewRequestPlanSlug[keyof typeof BillingChangePreviewRequestPlanSlug] | null;


export const BillingChangePreviewRequestPlanSlug = {
  solo: 'solo',
  growth: 'growth',
  business: 'business',
} as const;
